// Angular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Services
import { CoreService } from '../../../../shared/services/core.service';

// Models
import { AppCleanup } from '../../../../shared/models';
import { ReelViewModel } from '../models/reel-view.model';

@Injectable({
	providedIn: 'root',
})
export class ReelService extends AppCleanup {
	private reelUrl;

	constructor(
		private http: HttpClient,
		private coreService: CoreService
	) {
		super();
		this.reelUrl = `${this.apiUrl}api/asset/reel`;
	}

	getReels() {
		return this.http.get<ReelViewModel[]>(this.reelUrl);
	}

	getReel(id: number) {
		return this.http.get<ReelViewModel>(`${this.reelUrl}/${id}`);
	}

	createReel(reel: ReelViewModel) {
		return this.http.post<ReelViewModel>(`${this.reelUrl}`, reel);
	}

	updateReel(reel: ReelViewModel) {
		return this.http.put<ReelViewModel>(`${this.reelUrl}`, reel);
	}

	deleteReel(reelId: number) {
		return this.http.delete<ReelViewModel>(`${this.reelUrl}/${reelId}`);
	}
}
